import {
  Club, Disc3, LayoutGrid, Languages, Spade, Sparkles,
} from 'lucide-react';

// Canlı Casino sayfasının masa sekmeleri. Sekmeler masa adına göre süzer;
// anahtar kelimeler sunucuya gönderilir ki sayfalama ile birlikte tüm
// katalogda doğru çalışsın. Çipler ikon taşır: masa türü tek kelimeyle ayırt
// edilemediği için oyuncu şeridi ikonlardan tarar.
// Liste tek yerdedir: Betrun'un sol menüsü aynı sekmeleri "Canlı Casino"nun
// alt maddeleri olarak çizer (`?masa=<id>`) — ayrışırsa menüdeki bağlantı
// sayfada olmayan bir sekmeye giderdi.
export const LIVE_CASINO_TABS = [
  { id: 'all', name: 'Tüm Oyunlar', icon: LayoutGrid, keywords: '' },
  { id: 'roulette', name: 'Rulet', icon: Disc3, keywords: 'roulette,rulet' },
  { id: 'blackjack', name: 'Blackjack', icon: Spade, keywords: 'blackjack' },
  { id: 'baccarat', name: 'Baccarat', icon: Club, keywords: 'baccarat' },
  { id: 'shows', name: 'Show Oyunları', icon: Sparkles, keywords: 'crazy,monopoly,catcher,mega ball,deal or no deal,candy' },
  // Türkçe krupiyeli masalar sağlayıcı katalogunda ad üzerinden ayrılır;
  // yazım sağlayıcıdan sağlayıcıya değiştiği için dört varyant da aranır.
  { id: 'turkish', name: 'Türkçe Masalar', icon: Languages, keywords: 'turkish,türkçe,turkce,türk' },
];

// Sekme adreste taşınır: menüden gelen bağlantı ve yenilenen sayfa aynı
// sekmeyi açar. Tanınmayan değer "Tüm Oyunlar"a düşer.
export const LIVE_CASINO_TAB_PARAM = 'masa';

export const liveCasinoTabFrom = (search) => {
  const id = new URLSearchParams(search || '').get(LIVE_CASINO_TAB_PARAM);
  return LIVE_CASINO_TABS.some((t) => t.id === id) ? id : 'all';
};

export const liveCasinoTabPath = (id) => (
  id && id !== 'all' ? `/canli-casino?${LIVE_CASINO_TAB_PARAM}=${id}` : '/canli-casino'
);
